import { render } from "./pageComponent.vue?vue&type=template&id=2b52f93b&scoped=true"
import script from "./pageComponent.vue?vue&type=script&lang=js"
export * from "./pageComponent.vue?vue&type=script&lang=js"

import "./pageComponent.vue?vue&type=style&index=0&id=2b52f93b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b52f93b"]])

export default __exports__